(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 51421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12454);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Themed = function Themed(_ref) {
  var children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("light"),
      theme = _useState[0],
      setTheme = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setTheme((0,_helpers_theme__WEBPACK_IMPORTED_MODULE_2__/* .getCurrentTheme */ .g)());
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: "".concat(theme),
    children: children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Themed);

/***/ }),

/***/ 12454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ getCurrentTheme; }
/* harmony export */ });
/* unused harmony export setTheme */
var setTheme = function setTheme(theme) {
  if (true) {
    localStorage.setItem('theme', theme);
  }
};
var getCurrentTheme = function getCurrentTheme() {
  if (true) {
    return localStorage.getItem('theme') || "light";
  }

  return "light";
};

/***/ }),

/***/ 98565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _404; }
});

// EXTERNAL MODULE: ./components/Themed.jsx
var Themed = __webpack_require__(51421);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/error/Gear.jsx


var Gear = function Gear(_ref) {
  var color = _ref.color,
      animation = _ref.animation;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "100%",
    height: "100%",
    className: animation,
    viewBox: "0 0 159 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M77.1693 34.4184C102.298 33.293 123.588 52.6626 124.813 77.418C126.312 102.647 106.943 123.937 81.7009 125.482C56.5718 126.608 35.2825 107.238 34.1571 82.109C32.9441 57.3068 52.4139 35.6439 77.1693 34.4184ZM32.0295 25.2264C34.0125 28.661 31.6742 35.8931 30.2545 38.0155C28.4613 40.0378 24.3847 39.7464 20.7554 37.973C17.0793 36.1871 11.9033 38.5043 9.18405 43.9826C6.6775 48.6669 7.2875 54.2363 10.8043 56.43C14.8414 58.3627 16.0718 66.1006 15.4461 68.4357C15.2941 70.4974 11.7594 72.8539 7.6295 72.9486C2.96662 73.351 -0.0261694 78.3556 0.176026 83.7657C0.639216 89.6962 4.48355 94.03 8.626 93.8886C12.4415 93.6595 16.5321 95.2061 17.0865 97.8074C17.8411 99.6614 17.4176 107.407 13.5093 109.663C10.3483 112.12 10.0642 117.85 12.9019 122.765C16.2258 127.36 21.8042 129.705 24.9652 127.249C28.3997 125.266 35.6319 127.604 37.6075 129.385C39.7299 130.805 39.451 134.834 37.6651 138.51C35.7324 142.548 38.0963 147.736 43.5871 150.409C48.3181 152.928 53.9409 151.932 56.1346 148.415C57.9672 144.751 65.8052 143.147 68.1403 143.773C70.1552 143.912 72.4117 147.821 72.6532 151.59C73.1557 155.879 78.0602 159.245 83.5704 158.669C89.4008 158.58 93.622 155.156 93.493 150.967C93.3641 146.778 99.2659 141.752 101.64 140.736C103.494 139.981 107.431 142.288 109.514 145.349C111.771 149.257 117.501 149.541 122.516 146.33C127.111 143.006 129.357 137.801 127 134.266C125.017 130.832 127.355 123.6 129.149 121.577C130.456 119.875 134.598 119.734 138.274 121.52C142.211 123.826 147.5 121.089 150.119 115.984C152.738 110.879 151.855 104.836 148.225 103.063C144.562 101.23 143.231 93.8659 143.483 91.4307C143.836 88.6219 147.544 87.1126 151.413 86.4975C155.975 86.4687 158.956 81.5109 158.766 76.0541C158.303 70.1235 154.879 65.9024 150.69 66.0313C146.613 65.7399 141.475 60.2584 140.446 57.9307C139.804 55.6563 141.998 52.1396 145.533 49.783C149.067 47.4265 149.351 41.6961 146.14 36.6811C143.19 32.1865 137.612 29.8408 134.077 32.1973C130.642 34.1803 123.41 31.842 121.708 30.535C119.686 28.7417 119.591 24.6118 121.377 20.9357C123.583 17.3723 120.833 12.1304 115.829 9.13759C110.611 6.93874 105.101 7.51456 102.795 11.4516C100.962 15.1152 93.598 16.4456 91.1628 16.1935C88.8277 15.5678 86.8914 12.1458 86.4423 7.47042C86.2008 3.70159 81.3089 0.288483 75.7861 0.910999C69.9557 1.00057 65.3609 4.32446 65.7633 8.98734C65.5186 13.0764 60.1031 17.7821 57.3425 18.7443C55.4885 19.4989 51.8249 17.6663 49.5685 13.758C47.0993 10.6437 41.3815 10.313 36.4666 13.1506C31.8718 16.4745 29.5728 22.0654 32.0295 25.2264Z",
      fill: color
    })
  });
};

/* harmony default export */ var error_Gear = (Gear);
// EXTERNAL MODULE: ./node_modules/datamynt-ui-library/lib/index.esm.js
var index_esm = __webpack_require__(21627);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./pages/404.jsx







var Custom404 = function Custom404() {
  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Themed/* default */.Z, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dark:bg-dark-base bg-light-transparent px-8 w-screen h-screen flex flex-col items-center justify-center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "relative -left-8 sm:-left-10 top-8 sm:top-10 h-16 sm:h-24",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(error_Gear, {
          color: "#E5E5E5",
          animation: "animate-spin-slow"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex items-end",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "h-20 sm:h-28",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(error_Gear, {
            color: "#E5E5E5",
            animation: "animate-unspin-slow"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "h-28 sm:h-40",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(error_Gear, {
            color: "#3D8ECD",
            animation: "animate-spin-slow"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "space-y-6 flex flex-col py-8 items-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
          className: "text-primary text-center text-3xl sm:text-[2.5rem] font-bold font-Inter dark:text-white",
          children: "Page not found"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("h5", {
          className: "text-base sm:text-2xl text-center text-gray-30 dark:text-white font-normal",
          children: ["This page doesn\u2019t exist or was removed", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "We suggest you go back to the dashboard"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* ButtonSimpleRounded */.Vo, {
          grow: true,
          size: "md",
          onClick: function onClick() {
            return router.push("/dashboard");
          },
          label: "Back to dashboard"
        })]
      })]
    })
  });
};

/* harmony default export */ var _404 = (Custom404);

/***/ }),

/***/ 58671:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(98565);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(69898)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,2013,260,4617,9744,9866,3874,2757,6556,906,9774,2888,179], function() { return __webpack_exec__(58671); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);